"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwRadioButton = _interopRequireDefault(require("./CwRadioButton.scss"));

var CwRadioButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwRadioButton, _React$Component);

  function CwRadioButton() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CwRadioButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CwRadioButton)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function () {
      _this.input.click();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function () {
      if (_this.props.disabled || !_this.props.onChange) {
        return;
      }

      _this.props.onChange({
        id: _this.props.value.id,
        name: _this.props.value.name,
        checked: true // anytime a radiobutton is checked, it is selected

      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyPress", function (event) {
      if (_this.props.disabled || !_this.props.onChange || event.which !== 32) {
        return;
      }

      event.preventDefault(); // prevent scrolling on space key press

      _this.props.onChange({
        id: _this.props.value.id,
        name: _this.props.value.name,
        checked: true // anytime a radiobutton is checked, it is selected

      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleFocus", function () {
      if (_this.props.disabled || !_this.props.onFocus) {
        return;
      }

      _this.props.onFocus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleBlur", function () {
      if (_this.props.disabled || !_this.props.onBlur) {
        return;
      }

      _this.props.onBlur();
    });
    return _this;
  }

  (0, _createClass2.default)(CwRadioButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.wrap.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: _CwRadioButton.default.wrap,
        tabIndex: this.props.disabled ? -1 : this.props.tabIndex,
        disabled: this.props.disabled,
        readOnly: this.props.readOnly,
        ref: function ref(input) {
          return _this2.wrap = input;
        },
        onKeyPress: this.handleKeyPress,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick
      }, _react.default.createElement("div", {
        className: this.props.disabled ? _CwRadioButton.default.controlDisabled : _CwRadioButton.default.control
      }, _react.default.createElement("input", {
        ref: function ref(input) {
          return _this2.input = input;
        },
        type: "radio",
        name: this.props.groupName,
        disabled: this.props.disabled,
        onChange: this.handleChange,
        readOnly: this.props.readOnly,
        checked: this.props.value.checked === undefined ? false : this.props.value.checked
      }), _react.default.createElement("div", {
        className: this.props.invalid && !this.props.disabled ? _CwRadioButton.default.controlIndicatorInvalid : _CwRadioButton.default.controlIndicator
      }), this.props.value.name ? _react.default.createElement("label", {
        className: this.props.invalid && !this.props.disabled ? _CwRadioButton.default.controlLabelInvalid : _CwRadioButton.default.controlLabel
      }, this.props.value.name) : null));
    }
  }]);
  return CwRadioButton;
}(_react.default.Component);

CwRadioButton.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Object of with id, name used to identify the radio button, and checked state
   */
  value: _propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]),
    name: _propTypes.default.string,
    checked: _propTypes.default.bool
  }),

  /**
   * Identifier for group of radio buttons
   */
  groupName: _propTypes.default.string,

  /**
   * Used to set the radio button to disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Callback function fired when radio button changes
   */
  onChange: _propTypes.default.func,

  /**
   * Used to set the radio button to read only
   */
  readOnly: _propTypes.default.bool,

  /**
   * Used to control tab order
   */
  tabIndex: _propTypes.default.number,

  /**
   * Used to control if radiobutton is autofocused when the page loads
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func,

  /**
   * Used to display invalid state
   */
  invalid: _propTypes.default.bool
};
CwRadioButton.defaultProps = {
  tabIndex: 0
};
var _default = CwRadioButton;
exports.default = _default;